import MojitoCore from 'mojito/core';
import { STORE_KEY, INITIAL_STATE } from './slice.js';

const reduxInstance = MojitoCore.Services.redux;

/**
 * Favorites related selectors.
 *
 * @module FavoritesSelectors
 * @name selectors
 * @memberof Mojito.Services.Favorites
 */

/**
 * Selects favorites state.
 *
 * @function selectState
 *
 * @param {object} [state] - Application state object. If not provided then state from global {@link Mojito.Core.Services.redux|redux store} will be returned.
 * @returns {Mojito.Services.Favorites.FavoritesStoreState} Favorites state.
 * @memberof Mojito.Services.Favorites.selectors
 */
export const selectState = state => {
    // Should be no need to fallback to global state once fully migrated to Redux.
    const appState = state || reduxInstance.store?.getState();
    return appState?.[STORE_KEY] || INITIAL_STATE;
};

/**
 * Selects favorite events state.
 *
 * @function selectFavoriteEvents
 *
 * @param {object} [state] - Application state object.
 *
 * @returns {Array<string>} Array of favorite event Ids.
 * @memberof Mojito.Services.Favorites.selectors
 */
export const selectFavoriteEvents = state => selectState(state).events;
